export const excludedDomains = [
  'api.hubapi.com',
  'stats.g.doubleclick.net',
  'www.google-analytics.com',
  'api-js.mixpanel.com',
  'js.hs-banner.com',
  'api.hubspot.com',
  'cta-service-cms2.hubspot.com',
  'forms.hubspot.com',
  'vc.hotjar.io',
  'analytics.google.com',
  'region1.analytics.google.com',
]
